/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import SideMenu from "../../Components/SideMenu/SideMenu";
import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { useLocation, useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import cssClasses from "./Mainpage.module.css";
import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "../../Redux Store/store";
import actions from "../../Redux Store/actions";
import { supabase } from "../../supabaseClient";
import { useDispatch } from "react-redux";
import { getLead, logOut } from "../../Services/Login";
import { orderBy } from "lodash";
import { getUserDetails } from "../../Services/Leads";
import Badge from "@mui/material/Badge";

import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import { Avatar, Button, Divider, List, ListItem, ListItemIcon, ListItemText, useMediaQuery } from "@mui/material";
import HeaderSettingIcon from "../../Assets/Images/SideMenu/HeaderSetting.svg";
import HeaderBellIcon from "../../Assets/Images/SideMenu/Bell.svg";
import HeaderUserIcon from "../../Assets/Images/Common/Header-user.svg";
import DrawerIcon from "../../Assets/Images/Common/Vector.svg";
import HelpIcon from "../../Assets/Images/SideMenu/Help.svg";
import SettingsIcon from "../../Assets/Images/SideMenu/Settings.svg";
import LogoutIcon from "../../Assets/Images/SideMenu/Logout.svg";
import HelpActiveIcon from "../../Assets/Images/SideMenu/HelpActive.svg";
import SettingsActiveIcon from "../../Assets/Images/SideMenu/SettingsActive.svg";
import { makeStyles } from "@mui/styles";
import { errorTost } from "../../Services/Toast";
import PhoneCallIcon from "../../Assets/Images/Common/phone12profile.svg";
import MailIcon from "../../Assets/Images/Common/mail12profile.svg";
import backArrow from "../../Assets/Images/Common/backArrow.svg";
import Close from "../../Components/Icons/Close";
import ChangeUnitRequestsActiveIcon from "../../Assets/Images/SideMenu/CancelUnitActive.svg";
import ChangeUnitRequestsIcon from "../../Assets/Images/SideMenu/CancelUnit.svg";
import PreselectsActiveIcon from "../../Assets/Images/SideMenu/PreselecActive.svg";
import PreselectsIcon from "../../Assets/Images/SideMenu/preselect.svg";
import { func } from "prop-types";
import { SalesManagerCard } from "../../Components/Home/Home";
import { VirtaulAccountCard } from "../../Components/Profile/Profile";

const useStyles = makeStyles((theme) => ({
	menu_item: {
		marginBottom: "0.8rem",

		"&:hover": {
			borderRadius: "0.6rem !important",
			background: "#F8FAFC !important",
			color: "red !important",
			fontWeight: "600",
		},
		// border:"none! important",
		// background:"#FFFFF !important"
	},
	icon: {
		minWidth: "1.8rem !important",
		marginRight: "1.5rem",
	},
	menu: {
		margin: "0",
		"& span": {
			display: "inline-block",
			fontFamily: "Inter-Regular",
			fontSize: "1.4rem",
			lineHeight: "2rem",
			color: "#64748B",
			fontWeight: "500",
			letterSpacing: "-0.01em",
			"&:hover": {
				color: "#0F172A !important",
				fontWeight: "600",
				fontFamily: "Inter-Regular",
			},
		},
		"&:hover": {
			color: "#0F172A !important",
			fontWeight: "600",
		},
	},
	active: {
		background: "#EFF8FF !important",
		color: "#1570EF !important",
		borderRadius: window.innerWidth <= 820 ? "0px 20px 20px 0px !important" : "8px !important",
		"& span": {
			color: "#1570EF",
			fontWeight: "600",
			// background: "#1570EF"
			"&:hover": {
				color: "#1570EF !important",
			},
		},
		"&:hover": {
			background: "#F8FAFC !important",
			color: "#1570EF !important",
		},
	},
	user_avatar: {
		display: "inline-block !important",
		marginRight: "1.2rem !important",
		verticalAlign: "middle !important",
		width: "4rem !important",
		height: "4rem !important",
		borderRadius: "100%!important",
		objectFit: "contain",
	},
	speed_dial: {
		// position: 'absolute',
		// left: '50%',
		// background: "linear-gradient(136.4deg,rgba(23, 92, 211, 1) 0%,rgba(74, 139, 233, 1) 100% )",
		"& .MuiSpeedDial-fab": {
			background: "linear-gradient(136.4deg,rgba(23, 92, 211, 1) 0%,rgba(74, 139, 233, 1) 100% ) !important",
		},
		"& .MuiSpeedDialIcon-icon": {
			width: "3rem",
			height: "3rem",
		},
		"& .MuiSpeedDialAction-staticTooltipLabel": {
			fontSize: "1.6rem !important",
			lineHeight: "1.6rem !important",
			fontFamily: "Inter-Regular !important",
			wordBreak: "unset !important",
			boxShadow: "0px 2rem 2.4rem -0.4rem rgb(16 24 40 / 8%), 0px 0.8rem 0.8rem -0.4rem rgb(16 24 40 / 3%) !important",
			border: "1px solid #eaecf0 !important",
			background: "#D1E9FF",
			color: "rgb(23, 92, 211)",
		},
		"& .MuiSpeedDialAction-fab": {
			boxShadow: "0px 2rem 2.4rem -0.4rem rgb(16 24 40 / 8%), 0px 0.8rem 0.8rem -0.4rem rgb(16 24 40 / 3%) !important",
		},
		"& .MuiSpeedDialAction-fab > svg": {
			width: "3rem",
			height: "3rem",
			color: "#fff",
		},
	},
	add_lead_menu: {
		background: "linear-gradient(136.4deg,rgba(23, 92, 211, 1) 0%,rgba(74, 139, 233, 1) 100% ) !important",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "0.7rem",
		top: "0.2rem",
	},
}));
const drawerWidth = "20%";

function Mainpage(props) {
	const classList = useStyles();
	const { window1 } = props;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [mobileOpen, setMobileOpen] = useState(false);
	let loggedInUser = useSelector((state) => state.Auth.user);
	const activeMenu = useSelector((state) => state.ActiveMenu.activeMenu);
	const isWrap = useMediaQuery("(max-width:1024px)");
	const isPaddingRemove = useMediaQuery("(max-width:500px)");
	const path = useLocation();

	function defineColorSchema(status) {
		let obj = {};
		if (status === "Claimed") {
			obj.chipColor = "#FF4405";
			obj.chipBackgroundColor = "#FFE6D5";
		} else if (status === "Site Visit Done" || status === "Token Partial Payment Done" || status === "Token Refund Requested") {
			obj.chipColor = "#5925DC";
			obj.chipBackgroundColor = "#F4F3FF";
		} else if (status === "Site Visit Scheduled") {
			obj.chipColor = "#5925DC";
			obj.chipBackgroundColor = "#F4F3FF";
		} else if (status === "Site Visit Pending") {
			obj.chipColor = "#0E7090";
			obj.chipBackgroundColor = "#ECFDFF";
		} else if (status === "Token Payment Not Done") {
			obj.chipColor = "#C11574";
			obj.chipBackgroundColor = "#FDF2FA";
		} else if (status === "Token Payment Pending" || status === "Token Refund Request Rejected" || status === "Token Payment Complete") {
			obj.chipColor = "#3538CD";
			obj.chipBackgroundColor = "#EEF4FF";
		} else if (status === "Token Refunded") {
			obj.chipColor = "#3538CD";
			obj.chipBackgroundColor = "#EEF4FF";
		} else if (status === "Checkpoint One Cleared") {
			obj.chipColor = "#6941C6";
			obj.chipBackgroundColor = "#F4EBFF";
		} else if (status === "Checkpoint Two Cleared") {
			obj.chipColor = "#0E7090";
			obj.chipBackgroundColor = "#ECFDFF";
		} else if (status === "Allotment Partial Payment Done" || status === "Allotment Refunded" || status === "Preselect payment not done") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (status === "Unit On Hold") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (status === "Allotment Payment Pending" || status === "Payment Pending") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (status === "Change Unit Confirmation Pending") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (
			status === "Allotment Payment Complete" ||
			status === "Change Unit Requested" ||
			status === "Agreement Done" ||
			status.includes("Cancellation Confirmation Pending") ||
			status === "Cancel Unit Done" ||
			status === "Cancel Unit Not Done" ||
			status === "Cancellation Done" ||
			status === "Cancellation Not Done" ||
			status === "Change Unit Confirmation Rejected" ||
			status === "Change Unit Confirmed" ||
			status === "Change Unit Rejected" ||
			status === "Cancel Unit Requested" ||
			status === "PreSelect Unit On Hold" ||
			status === "Preselect not confirmed" ||
			status === "PreSelect Partial Payment Done" ||
			status === "PreSelect Price Confirmation Pending" ||
			status === "Unit Change Requested"
		) {
			obj.chipColor = "#5925DC";
			obj.chipBackgroundColor = "#F4F3FF";
		} else if (status === "PreSelect Price Confirmation Pending" || status === "PreSelect Confirmation Pending") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (status === "PreSelect Payment Pending") {
			obj.chipColor = "#6941C6";
			obj.chipBackgroundColor = "#F4EBFF";
		} else if (status === "Closed") {
			obj.chipColor = "#027A48";
			obj.chipBackgroundColor = "#ECFDF3";
		} else if (status === "Allotment Done") {
			obj.chipColor = "#5925DC";
			obj.chipBackgroundColor = "#F4F3FF";
		} else {
			obj.chipBackgroundColor = " #ececec";
			// obj.chipColor = "#667085";
		}

		return obj;
	}

	const drawer = (
		<div style={{ height: "100%" }}>
			<SideMenu
				props={(v) => {
					setMobileOpen(v);
				}}
			/>
		</div>
	);

	// function clickToProfile(){
	// 	console.log("click");
	// 	// toggleDrawer("left", false)
	// 	// navigate("Profile");
	// }

	const container = window1 !== undefined ? () => window().document.body : undefined;
	// !!SnapShot for leadStatus
	useEffect(() => {
		let leadList = [];
		let leadIds = [];
		leadList = JSON.parse(localStorage.getItem("LeadList"));
		leadList?.forEach((el) => {
			leadIds.push(el?.Leads[0]?.leadId);
		});
		if (loggedInUser) {
			let updateStatusListeners = supabase
				.from(`LeadStatus:leadId=in.(${leadIds})`)
				.on("UPDATE", (handleRecordUpdated) => {
					localStorage.setItem(
						"selectedLead",
						JSON.stringify({
							...loggedInUser,
							LeadStatus: [handleRecordUpdated.new],
						})
					);
					// !!Update Lead List
					getLead(loggedInUser?.personId?.contactNumber).then((resp) => {
						if (resp.data.length > 0) {
							resp.data.forEach((el) => {
								if (el.Leads.length > 0) {
									el.leadStatusObj = defineColorSchema(el.Leads[0].LeadStatus[0].status);
									el.lastUpdatedOnStatus = el.Leads[0].LeadStatus[0].last_updated_at;
								}
							});

							const FilterData = resp.data.filter((v) => v.Leads.length);
							localStorage.setItem("LeadList", JSON.stringify(orderBy(FilterData, "lastUpdatedOnStatus", "desc")));

							resp.data.map((e) => {
								if (e.personId === loggedInUser?.personId?.personId) {
									dispatch(
										actions.authLogin({
											...loggedInUser,
											personId: { ...loggedInUser.personId, name: e.name, email: e.email, contactNumber: e.contactNumber },
											LeadStatus: [handleRecordUpdated.new],
											razorpayCustomerId: e.Leads[0].razorpayCustomerId,
											virtualAccDetails: e.Leads[0].virtualAccDetails,
											leadResponse: e.Leads[0].leadResponse,
											virtualAccId: e.Leads[0].virtualAccId,
										})
									);
								}
							});
						}
					});
				})
				.subscribe((status) => {
				});
			console.log("added listner", loggedInUser.personId.personId)
			let updatePersonListner = supabase.from(`Person:personId=eq.${loggedInUser?.personId?.personId}`)
				.on("UPDATE", (handleRecordUpdated) => {
					let allUsers = JSON.parse(localStorage.getItem("LeadList"));
					let selectedUserfromArray = allUsers.find(({ personId }) => personId === loggedInUser?.personId?.personId);
					if (selectedUserfromArray) {
						selectedUserfromArray.name = handleRecordUpdated.new.name;
						selectedUserfromArray.Leads[0].personId.name = handleRecordUpdated.new.name;
						localStorage.setItem("LeadList", JSON.stringify(allUsers));
					}
					localStorage.setItem(
						"selectedLead",
						JSON.stringify({
							...loggedInUser,
							personId: {
								...loggedInUser.personId, name: handleRecordUpdated.new.name
							}
						})
					);
					dispatch(
						actions.authLogin({
							...loggedInUser,
							personId: { ...loggedInUser.personId, name: handleRecordUpdated.new.name },

						})
					);
				})

				.subscribe((status) => {
					console.log("status", status)
				});
			return () => {
				if (updateStatusListeners) {
					supabase.removeSubscription(updateStatusListeners);
					updateStatusListeners = null;
				}
				if (updatePersonListner) {
					supabase.removeSubscription(updatePersonListner);
					updatePersonListner = null;
				}
			};
		}
	}, []);
	// !! Snapshot for selected Lead if virtual account created it will reflect here..
	useEffect(() => {
		if (loggedInUser) {
			let updateStatusListeners = supabase
				.from(`Leads:leadId=eq.${loggedInUser.leadId}`)
				.on("UPDATE", (handleRecordUpdated) => {
					updateVirtualAccountDetails(handleRecordUpdated);
				})

				.subscribe((status) => {
				});
			return () => {
				if (updateStatusListeners) {
					supabase.removeSubscription(updateStatusListeners);
					updateStatusListeners = null;
				}
			};
		}
	}, [loggedInUser]);
	async function updateVirtualAccountDetails(handleRecordUpdated) {
		localStorage.setItem(
			"selectedLead",
			JSON.stringify({
				...loggedInUser,
				razorpayCustomerId: handleRecordUpdated.new.razorpayCustomerId,
				virtualAccDetails: handleRecordUpdated.new.virtualAccDetails,
				leadResponse: handleRecordUpdated.new.leadResponse,
				virtualAccId: handleRecordUpdated.new.virtualAccId,
			})
		);
		await getUserDetails(handleRecordUpdated.new.userId)
			.then((userRes) => {
				localStorage.setItem(
					"selectedLead",
					JSON.stringify({
						...loggedInUser,
						userId: userRes,
					})
				);
				dispatch(
					actions.authLogin({
						...loggedInUser,
						userId: userRes,
					})
				);
			})
			.catch((err) => {
				console.error(err);
			});
		// !!Update Lead List
		if (loggedInUser) {
			await getLead(loggedInUser?.personId?.contactNumber).then((resp) => {
				if (resp.data.length > 0) {
					resp.data.forEach((el) => {
						if (el.Leads.length > 0) {
							el.leadStatusObj = defineColorSchema(el.Leads[0].LeadStatus[0].status);
							el.lastUpdatedOnStatus = el.Leads[0].LeadStatus[0].last_updated_at;
						}
					});
					const FilteredData = resp.data.filter((v) => v.Leads.length);
					localStorage.setItem("LeadList", JSON.stringify(orderBy(FilteredData, "lastUpdatedOnStatus", "desc")));

					resp.data.map((e) => {
						if (e.personId === loggedInUser?.personId?.personId) {
							dispatch(
								actions.authLogin({
									...loggedInUser,
									razorpayCustomerId: handleRecordUpdated.new.razorpayCustomerId,
									virtualAccDetails: handleRecordUpdated.new.virtualAccDetails,
									leadResponse: handleRecordUpdated.new.leadResponse,
									virtualAccId: handleRecordUpdated.new.virtualAccId,
									personId: { ...loggedInUser.personId, name: e.name, email: e.email, contactNumber: e.contactNumber },
								})
							);
						}
					});
				}
			});
		}
	}
	useEffect(() => {
		if (!loggedInUser.leadId) {
			logoutUser();
		}
		// if (Capacitor.isNativePlatform()) {
		//   Keyboard.addListener("keyboardWillShow", (e) => {
		//     // console.log("keyboard will show, hiding bottom menu....");
		//     setKeyboardOpen(true);
		//   });
		//   Keyboard.addListener("keyboardDidHide", (e) => {
		//     // console.log("keyboard hidden, showing bottom menu....");
		//     setKeyboardOpen(false);
		//   });
		// }
		// return () => {
		//   if (Capacitor.isNativePlatform()) {
		//     Keyboard.removeAllListeners();
		//   }
		// };
	}, []);
	async function logoutUser() {
		await store.dispatch(actions.authLogout());
		logOut()
			.then(({ err }) => {
				if (err) {
					errorTost(err);
				} else {
					store.dispatch(actions.authLogout());
					localStorage.removeItem("supabase.auth.token");
					localStorage.removeItem("LeadList");
					localStorage.removeItem("selectedLead");
					navigate("/");
				}
			})
			.catch((error) => {
				errorTost(error);
			});
	}

	const [state, setState] = React.useState(false);

	const toggleDrawer = (anchor, open) => (event) => {
		if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
			return;
		}

		setState(open);
	};

	function clickToProfile() {
		// Adding a delay to ensure the drawer closes before navigating
		setTimeout(() => {
			navigate("/Home/Profile");
		}, 300);
		toggleDrawer("left", false);
	}

	const settingsArray = [
		{
			icon: <img src={PreselectsIcon} alt="preselect" />,
			activeIcon: <img src={PreselectsActiveIcon} alt="Prselect" />,
			name: "Preselect",
			tabName: "preselect",
			isVisible: true,
			path: "/Home/PreselectConfirmations",
			show: true,
		},
		{
			icon: <img src={ChangeUnitRequestsIcon} alt="cancelunit" />,
			activeIcon: <img src={ChangeUnitRequestsActiveIcon} alt="cancelunit" />,
			name: "Cancel Requests",
			tabName: "cancelunits",
			isVisible: true,
			path: "/Home/CancelUnitsRequest",
			show: true,
		},
		{
			icon: <img src={HelpIcon} alt={"help"} />,
			activeIcon: <img src={HelpActiveIcon} alt={"help"} />,
			name: "Help",
			tabName: "help",
			isVisible: true,
			path: "/Home/Help",
			show: true,
		},
		{
			icon: <img src={SettingsIcon} alt={"setting"} />,
			activeIcon: <img src={SettingsActiveIcon} alt={"setting"} />,
			name: "Settings",
			tabName: "profile",
			isVisible: true,
			path: "/Home/Profile",
			show: true,
		},
		{
			icon: <img src={LogoutIcon} alt={"logout"} />,
			activeIcon: <img src={LogoutIcon} alt={"logout"} />,
			name: "Logout",
			tabName: "logout",
			isVisible: true,
			path: "/Home/Help",
			show: true,
		},
	];
	const list = (anchor) => (
		<div className={cssClasses.menuMobile} onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
			<List>
				{settingsArray.map((menu, index) => (
					<div
						to={menu.path}
						key={`MenuArray_${index}`}
						onKeyDown={(e) => {
							navigate(menu.path);
						}}
						onClick={(e) => {
							if (menu.name === "Logout") logoutUser();
							navigate(menu.path);
						}}
					>
						<ListItem
							button
							key={menu.tabName}
							className={classList.menu_item}
							selected={activeMenu === menu.tabName.toLowerCase()}
							classes={{ selected: classList.active }}
						>
							<ListItemIcon className={classList.icon}>
								{" "}
								{activeMenu === menu.tabName.toLowerCase() ? menu.activeIcon : menu.icon}
							</ListItemIcon>
							<ListItemText primary={menu.name} className={classList.menu} />
						</ListItem>
					</div>
				))}
			</List>
		</div>
	);
	return (
		<Box
			sx={{ display: "flex" }}
			style={{
				height: "100%",
				flexDirection: isWrap ? "column" : "",
			}}
		>
			{!isWrap && (
				<>
					<CssBaseline />
					{/* <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        > */}

					<Toolbar
						className={cssClasses.wrapperMenu}
						sx={{
							width: !isWrap ? { sm: `calc(100% - ${drawerWidth}px)` } : `100%`,
							ml: { sm: `${drawerWidth}px` },
							alignItems: "flexStart !important",
							// position:'fixed'
						}}
					>
						{/* <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
            // sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton> */}
					</Toolbar>
					{/* </AppBar> */}
					<Box
						component="nav"
						sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
						aria-label="mailbox folders"
					// style={{ height: "100%" }}
					>
						{/* The implementation can be swapped with js to avoid SEO duplication of links. */}

						<Drawer
							variant="permanent"
							sx={{
								display: { xs: "block", sm: "block" },
								"& .MuiDrawer-paper": {
									boxSizing: "border-box",
									width: drawerWidth,
								},
							}}
							open
						>
							{drawer}
						</Drawer>
					</Box>
				</>
			)}
			<Box
				display={"flex"}
				flexDirection={"column"}
				// component="main"
				sx={{
					flexGrow: 1,
					width: "100%",
					// height: !isWrap ? "100%" : "90%",
					padding: 0,
					overflow: "hidden",
				}}
			>
				<Box className={cssClasses.headerData}>
					{!isWrap && (
						<>
							<Box className={cssClasses.headerTitle}>
								Hello <span style={{ fontSize: "1.6rem", lineHeight: "2.4rem" }}> {loggedInUser.personId.name}</span>
								{/* <Box className={cssClasses.headerSubTitle}>
							Your CUID is &nbsp;
							<span className={cssClasses.subTitleVjID}>
								#VJ{loggedInUser?.leadDisplayId.slice(0, -4) + "-" + loggedInUser?.leadDisplayId.slice(-4)}
							</span>
						</Box> */}
							</Box>

							<Box className={cssClasses.headerRightContent}>
								{" "}
								{/* <IconButton size="large" color="inherit">
							<img style={{ border: "1px solid #E2E8F0", borderRadius: "50px", padding: "10px" }} src={HeaderBellIcon} alt="setting" />
							<span
								style={{
									backgroundColor: "#EF4444",
									position: "absolute",
									top: "24px",
									right: "26px",
									height: "6px",
									width: "6px",
									borderRadius: "50px",
								}}
							></span>
						</IconButton>
						<IconButton size="large" color="inherit">
							<img
								style={{ border: "1px solid #E2E8F0", borderRadius: "50px", padding: "10px" }}
								src={HeaderSettingIcon}
								alt="setting"
							/>
						</IconButton> */}
								<Box className={cssClasses.headerSubTitle}>
									Your CUID is &nbsp;
									<span className={cssClasses.subTitleVjID}>
										#VJ
										{loggedInUser?.leadDisplayId.slice(0, -4) + "-" + loggedInUser?.leadDisplayId.slice(-4)}
									</span>
								</Box>
								<IconButton
									size="large"
									edge="end"
									aria-label="account of current user"
									color="inherit"
									onClick={() => navigate("Profile")}
								>
									<img className={cssClasses.headerUserImg} src={HeaderUserIcon} alt="profile" />
								</IconButton>
							</Box>
						</>
					)}
					{isWrap && (
						<>
							<div style={{ padding: "1.6rem 0" }}>
								<IconButton onClick={toggleDrawer("left", true)}>
									<img src={DrawerIcon} alt="menu" />
								</IconButton>
								<Drawer anchor="left" open={state} onClose={toggleDrawer("left", false)}>
									<Box className={cssClasses.sideMenuMainWrapper}>
										<Box className={cssClasses.sideMenuHeader}>
											<div className={cssClasses.wrapperHeader}>
												<div className={cssClasses.headerTitle}>
													Hello <span> {loggedInUser.personId.name}</span>
												</div>
												<span className={cssClasses.closeIcon} onClick={toggleDrawer("left", false)} tabIndex={0}>
													<Close width={"1.5rem"} height={"1.5rem"} />
												</span>
											</div>
											<Box className={cssClasses.mobileMenuHeader}>
												<div className={cssClasses.userName}>
													<div className={cssClasses.profileImgName}>
														<span className={cssClasses.name}>{loggedInUser?.personId?.name}</span>
														<div
															className={cssClasses.viewProfile}
															onClick={() => {
																setState(false);
																navigate("Profile");
															}}
														>
															View Profile
														</div>
														{/* <div onClick={(e)=>{navigate("Profile");toggleDrawer("left", false)}}>View Profile</div> */}
													</div>
												</div>
												<div className={cssClasses.salesMangerData}>
													<div className={cssClasses.userDetails}>
														<img className={cssClasses.profileImg} src={MailIcon} alt="call" />
														<span>{loggedInUser?.personId?.email}</span>
													</div>
													<div className={cssClasses.userDetails}>
														<img className={cssClasses.profileImg} src={PhoneCallIcon} alt="call" />
														<span>{loggedInUser?.personId?.contactNumber}</span>
													</div>
												</div>
											</Box>
											<Divider />
											{list("left")}
										</Box>
										<Box className={cssClasses.sideMenuHeader}>
											<div className={cssClasses.content}>
												<div className={cssClasses.profileCardHeader}>
													<div className={cssClasses.salesMangerText}>Your Sales Manager</div>
												</div>
												<div className={cssClasses.profileDetailsContent}>
													<div className={cssClasses.SalesManagerText}>{loggedInUser.userId?.name}</div>
													<div className={cssClasses.salesMangerData}>
														<div className={cssClasses.salesContentDetails}>
															<img className={cssClasses.profileImg} src={MailIcon} alt="mail" />{" "}
															{loggedInUser.userId?.email}
														</div>
														<div className={cssClasses.salesContentDetails}>
															<img className={cssClasses.profileImg} src={PhoneCallIcon} alt="call" />
															{loggedInUser.userId?.contactNumber}
														</div>
													</div>
												</div>
											</div>
										</Box>
									</Box>
								</Drawer>
							</div>
							<div className={cssClasses.activeMenuText}>{activeMenu}</div>
							<IconButton
								size="large"
								edge="end"
								aria-label="account of current user"
								color="inherit"
								onClick={() => navigate("Profile")}
							>
								<img className={cssClasses.headerUserImg} src={HeaderUserIcon} alt="profile" />
							</IconButton>
						</>
					)}
				</Box>
				<Box
					flex={1}
					style={{
						display: "flex",
						background: "#F9FAFB",
						padding: isPaddingRemove ? "1rem" : "3rem",
						gap: "2rem",
						flex: "1",
						overflow: "hidden",
						flexDirection: "row",
					}}
				>
					<Box
						width={isWrap ? "100%" : path.pathname !== "/Home/Profile" && path.pathname !== "/Home/Help" ? "70%" : "100%"}  
						sx={{ display: "flex", flex: "1", flexDirection: "column", overflow: "hidden" }}
					>
						<Outlet />
					</Box>
					{path.pathname !== "/Home/Profile" && path.pathname !== "/Home/Help" && path.pathname !== "/Home/UnitSelection" && path.pathname !== "/Home/UnitFloorMap" &&
					path.pathname !== "/Home/EMandateSplit" &&  path.pathname !== "/Home/BankVerification" && path.pathname !== "/Home/ConfirmPaymentSchedule" && 
					path.pathname !== "/Home/EMandateAllotmentHandlerPage" && path.pathname !== "/Home/SingleApplicant" && path.pathname !== "/Home/SplitAmount" && (
						<Box
							width={"30%"}
							display={isWrap ? "none" : "flex"}
							flexDirection={"column"}
							gap={"1rem"}
							height={"100%"}
							overflow={"auto"}
							paddingRight={"1rem"}
							paddingBottom={"1rem"}
						>
							<div>
								<SalesManagerCard style={{ width: "100%" }} />
							</div>
							<VirtaulAccountCard />
						</Box>
					)}
				</Box>
				{isWrap && (
					<SideMenu
						props={(v) => {
							setMobileOpen(v);
						}}
					/>
				)}
			</Box>
		</Box>
	);
}
export default Mainpage;
